/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-30 10:16:42
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-03-16 08:30:27
 */

import React from 'react';

const CopyRight = () => {
  const currentYear = new Date().getFullYear();
  return <>{`© ${currentYear}`}</>;
};

export default CopyRight;
